import React from "react";
import { Button, Input, Modal } from "@arco-design/web-react";
import { isBlank } from "../utils/validators";

// MUI Dialog(+Title/Content/Actions) -> Arco Modal (visible/onOk/onCancel/
// title/footer). TextField -> Input with a label above. Arco Input onChange
// passes the value, not an event.
export default function BroadcastDialog({ data, render, onSave }) {
  const [open, setOpen] = React.useState(false);
  const [broadcastName, setBroadcastName] = React.useState("");
  const [description, setDescription] = React.useState("");


  const handleClickOpen = () => {
    setOpen(true);
    setBroadcastName(data ? data.name : "");
    setDescription(data ? data.description : "");
  };


  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSave();
    }

    return false;
  }

  const handleClose = () => {
    setOpen(false);
  };

  const isValid = !isBlank(broadcastName);

  const handleSave = () => {
    if (!isValid) {
      return;
    }
    onSave && onSave({
      name: broadcastName,
      description: description,
    });
    handleClose();
  };

  return (
    <>
      {render(handleClickOpen)}
      <Modal
        visible={open}
        onCancel={handleClose}
        title={`${data ? "Edit" : "Add"} Broadcast `}
        footer={
          <>
            <Button onClick={handleClose} type="text">
              Cancel
            </Button>
            <Button onClick={handleSave} type="primary" disabled={!isValid}>
              Add
            </Button>
          </>
        }
      >
        <div style={{ marginBottom: 4 }}>Name</div>
        <Input
          autoFocus
          value={broadcastName}
          onChange={(value) => {
            setBroadcastName(value);
          }}
        />
        <div style={{ marginTop: 16, marginBottom: 4 }}>Description</div>
        <Input
          value={description}
          onChange={(value) => {
            setDescription(value);
          }}
          onKeyDownCapture={handleKeyPress}
        />
      </Modal>
    </>
  );
}
